export enum AuthzMiddlewareError {
  ActionKeyNotAllowed = '#f148d1ca',
  RestrictionMismatch = '#9299ef16',
}
